// --------------------------------------------------------------------------------------------
// --- HANDLE DISPLAY OF REFERENCES TO RECIPES IN BASKET --------------------------------------
// --------------------------------------------------------------------------------------------

export class RecipeTagsInjector {
  _recipeTagWrapper;
  _reduce;

  constructor(wrapper, reduce = false) {
    this._recipeTagWrapper = wrapper;
    this._reduce = reduce;
    this.initListMutationObserver();
  }

    /**
   * Init mutation Observer that will watch changes on
   * targetContainer and call injectRecipesTags method
   * each time a change is detected and one time at init
   */
     initListMutationObserver() {
      const targetcontainer = this._recipeTagWrapper.getTargetContainer();
      if(targetcontainer){
        const observedAtts = { attributes: false, childList: true, subtree: true };
        const listMutationObserver = new MutationObserver(
          this.injectRecipesTags.bind(this)
        );
        listMutationObserver.observe(this._recipeTagWrapper.getTargetContainer(), observedAtts);
        // console.debug('[Miam] dom lister init',listMutationObserver);
      }
      this.injectRecipesTags();
    }

  /**
   * replace placeholder div with class miamRecipesTag with our tag's component
   */
   injectRecipesTags() {
    const recipesTagsPlaceHolders = this._recipeTagWrapper.tagPlaceholders();
    while (recipesTagsPlaceHolders.length > 0) {
      // this will replace the placeholder and so decrease the recipesTagsPlaceHolders list
      this.initRecipeTag(recipesTagsPlaceHolders[0]);
    }
  }
  
  /**
   * Replace placeholder with miam-recipe-tag element 
   * set input with data-context content
   * @param {DOMElement} placeholder 
   */
  initRecipeTag(placeholder) {
    const recipeTagEl = document.createElement('webc-miam-recipe-tags');
    const extID = this._recipeTagWrapper.itemExtId(placeholder);
    recipeTagEl.recipeDetailPreviewAllowed = this._recipeTagWrapper.recipeDetailPreviewAllowed;
    recipeTagEl.extId = extID;
    recipeTagEl.reduce = this._reduce;
    placeholder.replaceWith(recipeTagEl);
  }
}
